

import { API_CENTRE } from "../config";
import _o2sService from "../_o2sServices";
import { IFilter } from "../../models/filters/filter";
import { ITypeProtocolFilter } from "../../models/filters/sanitaire/typeProtocolFilter";
import { ITypeProtocolForm } from "../../models/forms/sanitaire/typeProtocolForm";
import { ITypeProtocolPDTO } from "../../models/dtos/sanitaire/typeProtocolPDTO";

export default class TypeProtocolService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/TypeProtocol";

    protected static override  getUrlFilter<F extends ITypeProtocolFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.code != undefined)
                url += `&Code=${filter.code}`;
        }

        return url;
    }

    public static override toDTO(obj:ITypeProtocolForm):ITypeProtocolPDTO {
        const dto = super.toDTO(obj) as ITypeProtocolPDTO;
        return dto;
    }
}
